import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import { isCompositeComponent } from '../helpers';
export function prepareSlides(slides) {
  var currentSlide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var currentSlideIndex = currentSlide - 1;
  return slides.reduce(function (acc, slide, index) {
    return {
      slides: [].concat(_toConsumableArray(acc.slides), [prepareNode(/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      slide.node, index, currentSlideIndex)]),
      thumbnails: [].concat(_toConsumableArray(acc.thumbnails), [slide.thumbnailNode])
    };
  }, {
    slides: [],
    thumbnails: []
  });
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function prepareNode(node, nodeIndex, currentIndex) {
  if (isCompositeComponent(node)) {
    return /*#__PURE__*/React.cloneElement(node, {
      isFullscreenSlideActive: nodeIndex === currentIndex
    });
  }
  return node;
}